module.exports = __webpack_public_path__ + "img/task288.66cc583d.png";